import React, { useCallback, useEffect, useState } from 'react';
import Button from '~/app/common/Button';
import Icon from '~/app/common/Icon';
import Modal from '~/app/common/Modal';
import Quantity from '~/app/common/Quantity';
import useTranslation from '~/app/hooks/useTranslation';
import classes from './style.module.scss';

export interface QuantityEditModalProps {
  open: boolean
  onClose: () => void
  name: string
  subtitle?: string
  quantity: number
  onSave: (quantity: number) => void
}

export type QuantityEditModalComponent = React.FC<QuantityEditModalProps>

const QuantityEditModal: QuantityEditModalComponent = ({
  open,
  onClose,
  name,
  subtitle,
  quantity: initialQuantity,
  onSave,
}) => {
  const { t } = useTranslation('parts');
  const [quantity, setQuantity] = useState(initialQuantity);

  useEffect(() => {
    setQuantity(initialQuantity);
  }, [initialQuantity, open]);

  const handleSave = useCallback(() => {
    onSave(quantity);
    onClose();
  }, [quantity, onSave, onClose]);

  return (
    <Modal className={classes['quantityEdit']} open={open} onClose={onClose} position={'bottom'}>
      <div className={classes['partManager']}>
        <div className={classes['partsHeader']}>
          <Icon name="close" onClick={onClose} />
          <span>{t('editQuantity')}</span>
        </div>
        <div className={classes['row']}>
          {(name || subtitle) && (
            <div className={classes['partInfo']}>
              {name && <span className={classes['partName']}>{name}</span>}
              {subtitle && (
                <span className={classes['partNumber']}>{subtitle}</span>
              )}
            </div>
          )}
          <Quantity quantity={quantity} quantityChange={setQuantity} />
        </div>
        <Button className={classes['saveButton']} onClick={handleSave}>{t('save')}</Button>
      </div>
    </Modal>
  );
};

export default QuantityEditModal;
